import { cn } from "@tine/designsystem-utils";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import type { DeliveryDate } from "../../common/types/deliveryTypes";
import { formatDateTime } from "../../common/utils/dateUtils";
import deliveryDatesStore from "../../stores/deliveryDates/deliveryDatesStore";
import { formatTimePeriod, SIXTY_MINUTES, TEN_MINUTES } from "../../stores/deliveryDates/deliveryDateUtils";

type DeadlineMode = "GT60" | "LTE60" | "LTE10" | "expired" | "none";

const getMode = (deliveryDate: DeliveryDate | null, expiration: number | null): DeadlineMode => {
   if (deliveryDate && expiration !== null) {
      if (expiration === 0) {
         return "expired";
      }
      if (expiration > SIXTY_MINUTES) {
         return "GT60";
      }
      if (expiration > TEN_MINUTES) {
         return "LTE60";
      }
      return "LTE10";
   }
   return "none";
};

const deadlineClassName = cn(["w-[210px]"]);

const conspicuousClassName = cn([deadlineClassName, "text-error-600"]);

const Deadline = () => {
   const currentDelivery = deliveryDatesStore.getCurrentDelivery();
   const expiration = deliveryDatesStore.getCurrentDeliveryExpiration();

   const mode = useMemo(() => getMode(currentDelivery, expiration), [currentDelivery, expiration]);

   const formattedDate = currentDelivery ? formatDateTime(currentDelivery.deadline, true, true) : "";
   const formattedTimePeriod = typeof expiration === "number" ? formatTimePeriod(expiration) : "";
   const className = mode === "LTE10" || mode === "expired" ? conspicuousClassName : deadlineClassName;

   return (
      <>
         {mode === "GT60" && (
            <time className={className} dateTime={currentDelivery?.deadline.toISOString()}>
               {formattedDate}
            </time>
         )}
         {(mode === "LTE60" || mode === "LTE10") && <time className={className}>{formattedTimePeriod}</time>}{" "}
         {mode === "expired" && <span className={className}>Utløpt</span>}
      </>
   );
};

export default observer(Deadline);
